import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';

/**
 * Intro screen explaining the coverage change to the user
 */
const IntroScreen = ({ direction, currentType, targetType, onBack, onProceed }) => {
  const isDowngrade = direction === 'downgrade';

  const downgradeMessage = (
    <div>
      {/* Coverage Change Visual */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        marginBottom: '30px',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: '2px solid #e0e0e0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Current Coverage
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#032A37'
          }}>
            {currentType}
          </div>
        </div>
        <div style={{
          fontSize: '32px',
          color: '#ff6b6b',
          fontWeight: 'bold'
        }}>
          →
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            New Coverage
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#ff6b6b'
          }}>
            {targetType}
          </div>
        </div>
      </div>

      {/* Warning Box */}
      <div style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#856404',
            marginTop: '2px'
          }}>
            ⚠
          </div>
          <div>
            <div style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#856404',
              marginBottom: '8px'
            }}>
              Important: Members Will Be Removed
            </div>
            <div style={{
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#856404'
            }}>
              Only <strong>one Principal member</strong> will remain on this policy.
              All other family members will be removed from coverage.
            </div>
          </div>
        </div>
      </div>

      {/* Info Box */}
      <div style={{
        backgroundColor: '#e7f3ff',
        border: '1px solid #b3d9ff',
        borderRadius: '8px',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#0066cc',
            marginTop: '2px'
          }}>
            ℹ
          </div>
          <div>
            <div style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#032A37',
              marginBottom: '8px'
            }}>
              You Can Choose Your Principal
            </div>
            <div style={{
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#032A37'
            }}>
              On the next screen, you'll be able to select which member becomes the Principal
              (subject to age and eligibility requirements).
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const upgradeMessage = (
    <div>
      {/* Coverage Change Visual */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        marginBottom: '30px',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: '2px solid #e0e0e0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Current Coverage
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#032A37'
          }}>
            {currentType}
          </div>
        </div>
        <div style={{
          fontSize: '32px',
          color: '#28a745',
          fontWeight: 'bold'
        }}>
          →
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            New Coverage
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#28a745'
          }}>
            {targetType}
          </div>
        </div>
      </div>

      {/* Success Box */}
      <div style={{
        backgroundColor: '#d4edda',
        border: '1px solid #28a745',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#155724',
            marginTop: '2px'
          }}>
            ✓
          </div>
          <div>
            <div style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#155724',
              marginBottom: '8px'
            }}>
              Extended Family Coverage
            </div>
            <div style={{
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#155724'
            }}>
              Your policy will be upgraded to <strong>{targetType}</strong> coverage,
              allowing you to add spouse, children, and extended family members.
            </div>
          </div>
        </div>
      </div>

      {/* Info Box */}
      <div style={{
        backgroundColor: '#e7f3ff',
        border: '1px solid #b3d9ff',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#0066cc',
            marginTop: '2px'
          }}>
            ℹ
          </div>
          <div>
            <div style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#032A37',
              marginBottom: '8px'
            }}>
              Premium Adjustment
            </div>
            <div style={{
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#032A37'
            }}>
              Your premium will increase to the {targetType} rate. You can add
              family members now or later using the <strong>Manage Members</strong> amendment.
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e0e0e0'
      }}>
        <h1 style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '8px', color: '#032A37' }}>
          Change Coverage Type
        </h1>
        <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
          Review the changes that will be made to your policy
        </p>
      </div>

      {/* Message Content */}
      <div style={{ marginBottom: '30px' }}>
        {isDowngrade ? downgradeMessage : upgradeMessage}
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
        <ButtonInc
          btnType="secondary"
          onClick={onBack}
          style={{ border: '1px solid #032A37' }}
        >
          Back
        </ButtonInc>
        <ButtonInc
          btnType="primary"
          onClick={onProceed}
        >
          Proceed
        </ButtonInc>
      </div>
    </div>
  );
};

export default IntroScreen;
